// Demo data (L8): reset the shop floor's own data and seed instructions for
// the demo scenario's assembly, behind the data-reset role only.
import { useDemoData } from '../../api/queries';
import { canReset, useSession } from '../../auth/session';
import { Button, ErrorPanel, PageHeader } from '../../design/components';

export function DemoPage() {
    const session = useSession();
    const demo = useDemoData();
    if (!canReset(session)) {
        return (
            <section className="sf-stack">
                <PageHeader
                    title="Demo data"
                    description="Only the site’s owner and the automation sign-in can reset or seed data."
                />
            </section>
        );
    }
    return (
        <section className="sf-stack" aria-labelledby="demo-heading">
            <PageHeader id="demo-heading" title="Demo data" />
            <div className="sf-card sf-stack">
                <h2>Seed instructions</h2>
                <p>
                    Gives every assembly in the queue that has none a reviewed set of instructions, with cautions and
                    torque checks.
                </p>
                <div>
                    <Button
                        variant="primary"
                        disabled={demo.seed.isPending}
                        onClick={() => {
                            demo.seed.mutate();
                        }}
                    >
                        Seed instructions
                    </Button>
                </div>
                {demo.seed.isSuccess ? (
                    <p role="status">Seeded {demo.seed.data.instructionSetsSeeded} instruction set(s).</p>
                ) : null}
                {demo.seed.isError ? <ErrorPanel error={demo.seed.error} /> : null}
            </div>
            <div className="sf-card sf-stack">
                <h2>Reset</h2>
                <p>Removes every build, instruction set and photo. The next sync queues every delivered kit again.</p>
                <div>
                    <Button
                        variant="danger"
                        disabled={demo.reset.isPending}
                        onClick={() => {
                            if (window.confirm('Remove every build, instruction set and photo from the shop floor?'))
                                demo.reset.mutate();
                        }}
                    >
                        Reset shop floor data
                    </Button>
                </div>
                {demo.reset.isSuccess ? (
                    <p role="status">
                        Removed {demo.reset.data.buildsRemoved} build(s) and {demo.reset.data.instructionSetsRemoved}{' '}
                        instruction set(s).
                    </p>
                ) : null}
                {demo.reset.isError ? <ErrorPanel error={demo.reset.error} /> : null}
            </div>
        </section>
    );
}
